// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/index-shell.scss
// module id = 1561
// module chunks = 0